import { reduxKey } from './constants';
export var getCommentState = function (commentId) { return function (state) {
    return (commentId && state[reduxKey][commentId]) || {};
}; };
export var isInitialized = function (commentId) { return function (state) {
    return commentId &&
        state[reduxKey] !== undefined &&
        state[reduxKey][commentId] !== undefined;
}; };
export var isFeatured = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['isFeatured'];
}; };
export var isLiked = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['isLiked'];
}; };
export var isHidden = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['isHidden'];
}; };
export var isSpam = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['isSpam'];
}; };
export var getLikes = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['likes'];
}; };
export var isCommentReduxReady = function (state) { return !!state[reduxKey]; };
export function getCommentsByUser(state, userId) {
    var _a;
    var comments = state[reduxKey];
    var commentsByUser = [];
    for (var commentId in comments) {
        var comment = state[commentId];
        if (((_a = comment.user) === null || _a === void 0 ? void 0 : _a.userId) === userId) {
            commentsByUser.push(comment);
        }
    }
    return commentsByUser;
}
//# sourceMappingURL=selectors.js.map